<h3 mat-dialog-title>{{titulo}}</h3>
<form [formGroup]="formGroup" (ngSubmit)="filtrar()">
    <div mat-dialog-content style="width: 100%">
        <div class="profile-box friends" fxLayout="column">
            <div class="content">
                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>GRUPO</mat-label>
                        <input matInput formControlName="grupo" name="grupo" placeholder="GRUPO">
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>COTA</mat-label>
                        <input matInput formControlName="cota" name="cota" placeholder="COTA">
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Status</mat-label>
                        <mat-select placeholder="Status" formControlName="status_id" name="status_id">
                            <mat-option value="">SELECIONE</mat-option>
                            <mat-option *ngFor="let item of listStatusCartaConsorcio"
                                [value]="item.id">{{item.nome}}</mat-option>
                        </mat-select>
                        <mat-spinner diameter="20" *ngIf="loadingSpinnerStatusCartaConsorcio"></mat-spinner>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button type="button" tabindex="2" (click)="onNoClick()">
            Cancelar
        </button>
        <button mat-button type="submit" tabindex="-1">
            Filtrar
        </button>
    </div>
</form>